import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookie_consent", JSON.stringify({
      essential: true,
      analytics: true,
      accepted_at: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem("cookie_consent", JSON.stringify({
      essential: true,
      analytics: false,
      accepted_at: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto bg-white border border-slate-200 rounded-xl shadow-xl p-6">
        <div className="flex flex-col md:flex-row md:items-center gap-4">
          {/* Icon and Text */}
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Cookie className="h-5 w-5 text-amber-600" />
              <h3 className="font-semibold text-slate-900">We value your privacy</h3>
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              We use cookies to keep you logged in, remember your preferences, and improve our service.
              By clicking "Accept All", you consent to our use of cookies. Read our{" "}
              <a href="/privacy" className="text-blue-600 hover:underline">Privacy Policy</a> to learn more.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
            <Button
              variant="outline"
              onClick={acceptEssential}
              className="border-slate-200 text-slate-700 hover:bg-slate-50 rounded-lg px-4 py-2 text-sm"
              data-testid="cookie-essential-btn"
            >
              Essential Only
            </Button>
            <Button
              onClick={acceptAll}
              className="bg-slate-900 text-white hover:bg-slate-800 rounded-lg px-4 py-2 text-sm"
              data-testid="cookie-accept-btn"
            >
              Accept All
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
